import Skeleton from 'react-loading-skeleton';
import SC from './StoreAssetCard.module.scss';
import SG from './StoreGrid.module.scss';
import SL from './StoreList.module.scss';
export const StoreAssetSkeleton = () => {
  return <>
      <Skeleton style={{
      width: '100%',
      height: '128px',
      margin: '30px 0'
    }} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
      <div className={SL.main_wrapper}>
        <div className={SL.title_wrapper}>
          <Skeleton width={180} height={24} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
        </div>
        <div className={SG.store_grid}>
          {Array.from({
          length: 3
        }).map((_, index) => <div className={SC.card_wrapper} key={index}>
              <div className={SC.card_thumbnail_wrapper}>
                <Skeleton className={SC.item_img_thumbnail} />
              </div>
              <div className={SC.store_text}>
                <Skeleton style={{
              width: '70%',
              height: '16px'
            }} />
                <div className={SC.item_title}>
                  <Skeleton style={{
                width: '40%'
              }} />
                </div>
                <div className={SC.item_price}>
                  <Skeleton style={{
                width: '20%'
              }} />
                </div>
              </div>
            </div>)}
        </div>
        <div className={SG.spacer} />
      </div>
      <div className={SL.main_wrapper}>
        <div className={SL.title_wrapper}>
          <Skeleton width={180} height={24} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
        </div>
        <div className={SG.store_grid}>
          <Skeleton width={270} height={73.5} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
          <Skeleton width={270} height={73.5} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
        </div>
        <div className={SG.spacer} />
      </div>
      <div className={SL.main_wrapper}>
        <div className={SL.title_wrapper}>
          <Skeleton width={180} height={24} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
        </div>
        <div className={SG.store_grid}>
          <div className={SC.card_wrapper}>
            <div className={SC.card_thumbnail_wrapper}>
              <Skeleton className={SC.item_img_thumbnail} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
            </div>
            <div className={SC.store_text}>
              <Skeleton style={{
              width: '70%',
              height: '16px'
            }} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
              <div className={SC.item_title}>
                <Skeleton style={{
                width: '40%'
              }} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
              </div>
              <div className={SC.item_price}>
                <Skeleton style={{
                width: '20%'
              }} data-sentry-element="Skeleton" data-sentry-source-file="StoreAssetsSkeleton.tsx" />
              </div>
            </div>
          </div>
        </div>
        <div className={SG.spacer} />
      </div>
    </>;
};